var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[(_vm.getMe)?_c('v-container',[_c('h1',{staticClass:"pt-3"},[_vm._v("Salut "+_vm._s(_vm.getMe.name)+"!")])]):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-row',[_c('v-col')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }